import Loading from "react-loading";
import { ContainerLoading } from "../../styles-components/Container";

export default function LoadingEffect() {
  return (
    <ContainerLoading>
      <Loading type={'bubbles'} color={"#e65400"} height={'100px'} width={'100px'} />
    </ContainerLoading>
  )
};
